import { Select } from '@apollo/space-kit/Select';
import React from 'react';
import { SelectChangeEvent } from 'typings/events/selection-change-event';

import { DateRangeBadge } from 'src/components/dateRangeBadge/DateRangeBadge';

import { SubscriptionRegistrationInfoIcon } from './SubscriptionRegistrationInfoIcon';
import { LatencyChartType } from './types';

interface RequestLatencyOverTimeHeadingProps {
  chartType: string;
  onChartTypeChange: (event: SelectChangeEvent<LatencyChartType>) => void;
  isSubscriptionOperation: boolean;
}

export function RequestLatencyOverTimeHeading({
  chartType,
  onChartTypeChange,
  isSubscriptionOperation,
}: RequestLatencyOverTimeHeadingProps) {
  return (
    <>
      <Select
        value={chartType}
        onChange={onChartTypeChange}
        feel="flat"
        className="font-heading text-xl font-medium text-heading"
        placement="bottom-start"
      >
        <option className="font-normal" value="heatmap">
          {isSubscriptionOperation
            ? 'Subscription registration latency'
            : 'Request latency'}
        </option>
        <option className="font-normal" value="p50">
          {isSubscriptionOperation
            ? 'P50 subscription registration latency'
            : 'P50 request latency'}
        </option>
        <option className="font-normal" value="p90">
          {isSubscriptionOperation
            ? 'P90 subscription registration latency'
            : 'P90 request Latency'}
        </option>
        <option className="font-normal" value="p95">
          {isSubscriptionOperation
            ? 'P95 subscription registration latency'
            : 'P95 request latency'}
        </option>
      </Select>
      {isSubscriptionOperation && <SubscriptionRegistrationInfoIcon />}
      <DateRangeBadge />
    </>
  );
}
